import React from 'react';

/**
 * Help page navigation icon
 */
function HelpNavIcon() {
  return (
    <svg
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 602.6 601.9"
      className="c-icon-nav-size-24"
    >
      <g>
        <g>
          <g>
            <path
              className="c-icon-nav-path"
              d="M593.1,301.1c0.3,157.4-133,290.9-291.1,291.3C144.1,592.8,10.9,459.8,10.3,301.2C9.7,143.8,142.8,10.2,300.9,9.6C459.1,9.1,592.8,142.4,593.1,301.1z M557.1,301c0-143.1-112-255.3-255.1-255.5C158.8,45.2,46.1,157.7,46.1,301C46,443.9,158,556,301.3,556.4C444.5,556.8,557,444.4,557.1,301z"
            />
            <path
              className="c-icon-nav-path"
              d="M301.2,601.9C138.9,601.9,1.4,464.4,0.7,301.2C0.4,222.6,31.9,147.5,89.3,89.9C146.8,32.3,221.9,0.4,300.9,0.1c0.4,0,0.7,0,1.1,0c78.5,0,153.2,31.4,210.6,88.4c57.9,57.6,89.9,133,90,212.5l0,0c0.3,162.6-137.3,300.4-300.6,300.8C301.8,601.9,301.5,601.9,301.2,601.9z M302,19.2c-0.3,0-0.7,0-1,0c-73.9,0.3-144.3,30.2-198.1,84.2c-53.8,54-83.3,124.2-83,197.8C20.4,454,149.2,582.8,301.2,582.8c0.3,0,0.5,0,0.8,0c152.9-0.4,281.9-129.5,281.6-281.8l0,0c-0.1-74.4-30.1-145-84.4-199C445.4,48.6,375.4,19.2,302,19.2z M302,565.9c-0.3,0-0.5,0-0.8,0C152.8,565.5,36.5,449.1,36.5,301c0-71.8,27.4-138.7,77.1-188.3c49.6-49.5,116.3-76.7,187.9-76.7c0.1,0,0.3,0,0.4,0C450.4,36.1,566.6,152.6,566.6,301l0,0l0,0c0,72-27.4,139-77.1,188.6C440,538.8,373.5,565.9,302,565.9zM301.5,55c-66.5,0-128.5,25.3-174.4,71.1C81,172.1,55.6,234.2,55.6,301c-0.1,137.5,107.9,245.5,245.7,245.9c0.2,0,0.5,0,0.7,0c66.4,0,128.1-25.1,174-70.9c46.1-46,71.5-108.1,71.5-175.1l0,0c0-137.7-107.9-245.8-245.6-246C301.8,55,301.7,55,301.5,55z"
            />
          </g>
          <g>
            <path
              className="c-icon-nav-path"
              d="M301,143.2c42-0.2,83.3,27.2,96.9,64.2c11.7,31.8,1.2,70-26.4,93.2c-8.7,7.3-18.2,13.9-27.9,19.9c-13.1,8.2-20.3,18.7-18.3,34.7c0.9,7.7-1.5,14.3-8.5,18.6c-11.5,7-26-0.5-27.2-14.3c-2.5-27.3,5.9-49.7,29.3-65.5c7.7-5.2,15.4-10.5,23.3-15.6c20.5-13.1,27.6-32.2,23.5-55.4c-3.8-21.8-18.6-34.1-38.8-40.4c-20.6-6.3-41.1-5.5-60.8,3.6c-14.1,6.5-24,17.1-30.2,31.4c-4.1,9.4-12.2,13.8-20.7,11.8c-11.4-2.6-17.2-14.1-12.4-25.3c10.2-23.5,28.4-39.3,50.9-50.3C268.5,146.7,284.4,143.1,301,143.2z"
            />
            <path
              className="c-icon-nav-path"
              d="M307.4,386.1c-4.1,0-8.3-1-12.1-2.9c-8.6-4.3-14.3-12.8-15.2-22.7c-3-32.4,8.3-57.4,33.4-74.3l6.5-4.4c5.6-3.8,11.2-7.6,17-11.3c16.5-10.6,22.8-25.5,19.3-45.7c-2.9-16.3-13.4-27.1-32.2-32.9c-18.8-5.8-37-4.7-54,3.2c-11.7,5.4-20,14-25.4,26.5C238.7,235,226,242,213,238.9c-8.2-1.9-15-7.1-18.6-14.3c-3.7-7.3-3.8-16.1-0.4-24.1c10.4-23.8,28.5-41.9,55.5-55.1c16.3-8,33.6-11.8,51.5-11.8c0.2,0,0.3,0,0.5,0c46.1,0,90.3,29.6,105.4,70.5c13.1,35.6,1.1,78.3-29.2,103.8c-8.2,6.9-17.4,13.4-29,20.7c-11.2,7-15.3,14.4-13.9,25.5c1.5,12-3.1,21.9-13,27.9C317.3,384.7,312.4,386.1,307.4,386.1z M300.5,169.2c9.6,0,19.3,1.5,29.1,4.5c25.6,7.9,41.3,24.4,45.4,47.8c4.9,27.8-4.7,50.3-27.7,65.1c-5.6,3.6-11.1,7.3-16.5,11l-6.6,4.4c-19.2,12.9-27.4,31.5-25.1,56.7c0.3,3.3,2.1,6,4.8,7.4c1.5,0.7,4.5,1.7,8-0.4c2.4-1.4,4.7-3.7,4-9.3c-2.3-18.3,5.4-33.2,22.7-44c10.9-6.8,19.4-12.9,26.8-19.1c24.3-20.4,34-54.4,23.6-82.6c-12.2-33.1-49.8-58-87.5-58c-0.1,0-0.3,0-0.4,0h-0.1c-15-0.3-29.4,3.1-43,9.8c-22.7,11.1-37.9,26-46.4,45.6c-1.2,2.8-1.3,5.6-0.1,7.9c1.1,2.2,3.2,3.7,5.8,4.3c5.8,1.3,8.8-4,9.9-6.4c7.3-16.7,19-28.9,34.9-36.2C274.4,172.1,287.3,169.2,300.5,169.2z"
            />
          </g>
          <g>
            <path
              className="c-icon-nav-path"
              d="M324,431.4c0,12.5-7.4,20.7-18.4,20.3c-11.5-0.4-18.5-10-17.4-24c0.9-10.8,9.7-18.2,20.5-16.9C318.4,411.9,324,419.5,324,431.4z"
            />
            <path
              className="c-icon-nav-path"
              d="M306.2,461.2c-0.3,0-0.6,0-0.9,0c-7.5-0.2-14.3-3.3-19.1-8.7c-5.6-6.3-8.3-15.4-7.5-25.6c0.6-7.9,4.2-14.8,10-19.6c5.8-4.8,13.3-6.9,21-6c14.7,1.7,23.8,13.3,23.8,30.1c0,9.1-3.1,17.1-8.7,22.6C319.9,458.7,313.3,461.2,306.2,461.2z M306.2,420.2c-2.1,0-4,0.6-5.5,1.9c-1.8,1.5-2.9,3.8-3.1,6.4c-0.4,4.9,0.6,9.1,2.7,11.4c1.3,1.5,3.2,2.3,5.5,2.3c2.5,0,4.3-0.6,5.6-1.9c1.9-1.8,2.9-5,2.9-8.9l0,0c0-10.3-5.2-10.9-6.9-11.1C307.1,420.2,306.6,420.2,306.2,420.2z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default HelpNavIcon;



// WEBPACK FOOTER //
// ./src/layout/graphics/NavIcons/HelpNavIcon.js